import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-warm px-4 py-6 sm:py-8" data-id="element-73" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-3xl items-start gap-4 rounded-xl border-2 border-teal/50 bg-white p-4 shadow-sm sm:p-5" data-id="element-74" data-mp="1o3dmib9hgbqm">
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-ice text-teal" data-id="element-75" data-mp="1x4bravrqwna9">
          <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-76" data-mp="19ehege7feyq0" />
        </span>
        <div data-id="element-77" data-mp="19cek5hz8qjfh">
          <h2 className="text-xl leading-none text-navy sm:text-2xl" data-id="element-78" data-mp="14fxugjce7x0a">
            Your purchase is 100% protected
          </h2>
          <p className="mt-1.5 text-sm font-medium leading-snug text-slate2 sm:text-base" data-id="element-79" data-mp="1j5ltfdx3qjku">
            Explore PROSTHODONTICS VISUAL ATLAS™ for 14 days. Review the six visual modules,
            classifications, component guides, comparison resources, workflow overviews,
            revision tools and five bonuses. If the system isn’t right for you, contact us
            within 14 days for a full refund according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}